import { useParams } from "@tanstack/react-router";

export function useActiveChatId(): string | undefined {
  return useParams({
    strict: false,
    select: (params) => params.chatId,
  });
}
